import { Sparkles, Layers, Flame, Gem } from "lucide-react";

const offerings = [
  { icon: Sparkles, title: "Custom Showers", desc: "Curbless walk-ins, steam enclosures, and feature walls built to last decades." },
  { icon: Layers, title: "Kitchen Backsplashes", desc: "Hand-set tile and stone that anchors the room and elevates the whole kitchen." },
  { icon: Flame, title: "Fireplace Surrounds", desc: "Floor-to-ceiling stone, marble, and tile installations that become the centerpiece." },
  { icon: Gem, title: "Mosaics & Feature Walls", desc: "Intricate hand-laid mosaic work — a craft we've refined over 30 years." },
];

export function ProblemSolved() {
  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="container-prose">
        <div className="max-w-2xl mb-16">
          <span className="eyebrow">What we craft</span>
          <h2 className="mt-3 font-display text-3xl md:text-5xl text-foreground leading-tight">
            Custom tile work, made to be lived with for decades.
          </h2>
          <p className="mt-5 text-muted-foreground text-lg leading-relaxed">
            From statement showers and kitchen backsplashes to fireplace surrounds and intricate mosaics —
            every project is hand-set by craftsmen with 30 years behind every cut.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border border border-border">
          {offerings.map((p) => (
            <div key={p.title} className="bg-background p-8 hover:bg-muted/50 transition-colors">
              <p.icon className="h-8 w-8 text-primary mb-6" strokeWidth={1.4} />
              <h3 className="font-display text-xl text-foreground">{p.title}</h3>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
